// © 2013 - 2021 Tinder, Inc., ALL RIGHTS RESERVED

import React, { createElement, useContext } from 'react';

import { Theme } from '@tinderapp/ui-core';

import { UiEngineThemesContext, UiEngineThemeIdContext } from '../../contexts/UiEngine';

export interface ThemeVariablesProps {
  namespace?: string;
  cssScope?: string;
  theme: Theme;
}

interface Props {
  themeVariablesComponent: React.FunctionComponent<ThemeVariablesProps>;
  theme?: Theme;
  themes?: Record<string, Theme>;
}

const ThemeGlobalStyles: React.FunctionComponent<Props> = ({
  themeVariablesComponent: ThemeVariables,
  theme: explicitTheme,
  themes: explicitThemes,
}) => {
  const currentThemes = useContext(UiEngineThemesContext);
  const themes = explicitThemes || currentThemes;
  const currentThemeId = useContext(UiEngineThemeIdContext);
  const theme = explicitTheme || themes[currentThemeId];

  if (!ThemeVariables) {
    return null;
  }

  return (
    <>
      {theme ? createElement(ThemeVariables, { theme }) : null}
      {Object.entries(themes).map(([themeId, theme]) =>
        createElement(ThemeVariables, { key: themeId, namespace: themeId, theme })
      )}
    </>
  );
};

export default ThemeGlobalStyles;
